import React, { lazy, Suspense, useMemo, useEffect } from "react"
import Header from "./Header"
import Footer from "./Footer"
import ClassBuilder from "./ClassBuilder"
import PopUpLayout from "./PopUpLayout"
import { withRouter } from "react-router"
import { ToastContainer } from "react-toastify"
import Logger from "./logger"
import ErrorBoundary from "./ErrorBoundary"

const Gamification2026Layout = ({ client, children, className, campaign, toRender, fontFamily, features, location }) => {

  // Scroll to the top of the page on every route change so the user always
  // starts at the top when navigating (e.g. list → detail → back to list).
  // `location` is injected by the withRouter() HOC at the bottom of this file.
  useEffect(function() {
    window.scrollTo(0, 0)
  }, [location.pathname])

  Logger.debug('Campaign Props:', campaign);

  const container = [
    "gl-layout gl-p-container default-bg py-10 gl-catalog__container mb:pt-0",
    !className && "default-bg",
    className
  ].join(" ")

  const slug = campaign && campaign.slug;

  /**
   * Memoised lazy component for per-slug footer overrides.
   *
   * React.lazy() must NOT be called on every render — doing so resets the
   * suspended module state and causes an infinite re-fetch loop.  useMemo
   * with [slug] as the dependency ensures the lazy reference is stable
   * across renders and only regenerated when the campaign changes.
   *
   * The .catch() returns the default Footer as the module's default export
   * when the campaign-specific file does not exist, so FooterComponent is
   * always a valid React component and Suspense always has something to mount.
   */
  const FooterComponent = useMemo(
    () =>
      lazy(() =>
        import(`./Footer${slug}`).catch(() => ({ default: Footer }))
      ),
    [slug] // eslint-disable-line react-hooks/exhaustive-deps
  );

  Logger.debug('Valor de clientSlug:', client.slug);
  return (
    <ClassBuilder className="template-root" campaign={campaign}>
      <Header features={features} toRender={toRender} fontFamily={fontFamily} />
      <div className="template-container">
        <main className={container}>
          <ErrorBoundary>{children}</ErrorBoundary>
        </main>
      </div>
      <PopUpLayout fontFamily={fontFamily} />
      {/* Render per-slug footer if it exists, fall back to default Footer */}
      <Suspense
        fallback={
          <Footer
            fontFamily={fontFamily}
            campaign={campaign}
            features={features}
            clientSlug={client.slug}
          />
        }
      >
        <FooterComponent
          fontFamily={fontFamily}
          campaign={campaign}
          features={features}
          clientSlug={client.slug}
        />
      </Suspense>

      {/* Toast notification container */}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </ClassBuilder>
  );
}

export default withRouter(Gamification2026Layout)
